/**
 * Created by zac on 17/06/2016.
 */
// import { recordTinCanAction, recordActivity } from './lobuilder.jquery';
// import { RecordSCORMinteraction } from './scormfunctions';
import Debug from 'debug';
import Cookies from 'js-cookie';

const debug = Debug('gh:lobuilder:matching');
$(() => {
  function handleInfoDrop(event, ui) { // fired when a matching activity has it's draggable element dropped onto a droppable target
    debug('Handling a info drop');
    const infoID = $(this).attr('data-id');
    const flexibleBehaviour = $(this).attr('data-flex');
    let points = $(this).attr('data-score');
    if (points === '') points = 0;
    const targetID = ui.draggable.attr('data-id');
    const id = $(this).attr('data-parent');
    let correct = 'No';
    // record the attempt for priorlearning page
    // var activityID = $(this).closest(".sequence-activity-content").attr("div");
    const activityID = $(this).closest('.isActivity').attr('id');
    if (window.checkActivitiesDone && $.inArray(activityID, window.checkActivitiesDone) == -1) {
      window.checkActivitiesDone.push(activityID);
    }
    // console.log(flexibleBehaviour);
    if (flexibleBehaviour == 'Yes') {
      debug('using flexibleBehaviour');
      // regardless of whether the info was dropped to the correct target,
      // change the info div colour and position it directly
      // on top of the target div
      debug('correct if match', infoID, targetID);
      if (infoID == targetID) {
        debug('Is placed correctly');
        $(`#matchingFeedback${infoID}`).addClass('alert-success');
        correct = 'Yes';
        ui.draggable.addClass('matchingresult-correct');
        if (points > 0) {
          // console.log("$('.score', '#scoreboard'+id).text() "+$('.score', '#scoreboard'+id).text());
          $('.score', `#scoreboard${id}`).text(parseInt(points) + parseInt($('.score', `#scoreboard${id}`).text()));
        }
      } else {
        debug('Not placed correctly');
        $(`#matchingFeedback${infoID}`).addClass('alert-error');
        ui.draggable.addClass('matchingresult-incorrect');
        // record the failure for the priorlearning page
        window.sectionscore = parseInt(window.sectionscore, 10) - 1;
        // record incorrect responses for later reporting on prior learning pages
        const heading = $(`#matchingInfo${infoID}`).closest('.isActivity').data('heading');
        // if ($.inArray(heading, window.checkIncorrectActivities) == -1) {
        //     window.checkIncorrectActivities.push(heading);
        // }
      }
      ui.draggable.addClass('correct');
      ui.draggable.position({
        of: $(this),
        my: 'left top',
        at: 'left top',
      });
      ui.draggable.draggable('option', 'revert', false);
    } else {
      // If the info was dropped to the correct target,
      // change the info div colour, position it directly
      // on top of the target div, and prevent it being dragged
      // again
      debug('correct if match', infoID, targetID);
      if (infoID == targetID) {
        debug('Placed correctly');
        ui.draggable.addClass('correct');
        correct = 'Yes';
        ui.draggable.draggable('disable');
        $(this).droppable('disable');
        ui.draggable.position({
          of: $(this),
          my: 'left top',
          at: 'left top',
        });
        ui.draggable.draggable('option', 'revert', false);
      }
    }
    // set the target area height
    if ($(this).height() < ui.draggable.height()) { // but only if the target is shorter
      $(this).css('height', ui.draggable.css('height'));
      $(this).css('width', ui.draggable.css('width'));
      // TODO make sure you move the contents of other target areas that have been shoved down by a new bigger target so that they're still in their original container
    }
    // get the parameters for SCORM reporting
    const activitynum = $(this).attr('data-parent');
    const minscore = $(id).attr('data-minscore');
    const maxscore = $(id).attr('data-maxscore');
    if ($(this).attr('data-hideFromSCORM') == 'No') { // send an interaction report back to the LMS
      let activityDetails = $(this).attr('data-SCORMdescription');
      if (activityDetails == '') {
        activityDetails = `${$('.page-title').text()} - ${$(this).attr('data-activity-name')} - Matching pair Q: ${$(`#MatchingQ${activitynum}`).text()}`;
      }
      // record the result in SCORM
      const pairID = $(this).attr('data-id');
      const response = `${$(`#matchingInfo${targetID}`).text()} dragged on to ${$(this).text()} Correct-${correct}`;
      let rawscore = points;
      if (points == 0 && correct == 'Yes') rawscore = 10;
      // console.log("Cloze test SCORM interaction... activityDetails:"+activityDetails+" rawscore:"+rawscore+" response:"+response);
      // RecordSCORMinteraction(activityDetails, rawscore, response);
    } // end check to see if we're reporting this back to the LMS

    // record overall progress in SCORM
    // recordActivity($(this).attr('data-activity-name'), $(this).attr('data-activitynum'));

    // record result via xAPI
    // recordTinCanAction(id,activityname,question,response)
    // recordTinCanAction(`${window.location}_dnd${infoID}`,
    //     `${$('.page-title').text()} - ${$(this).attr('data-activity-name')} - Matching pair`,
    //     $(`#MatchingQ${activitynum}`).text(),
    //     response, rawscore);

    if (correct == 'Yes') {
      if (Cookies.get($(this).parent('id')) === 'QuestionDone') {} else {
        window.totalscore = parseInt(window.totalscore, 10) + parseInt(points, 10);
        Cookies.set($(this).parent('id'), window.totalscore, {
          expires: 7,
          path: '/',
        });
        if (Cookies.get('finalscore')) {
          var finalscore = parseInt(Cookies.get('finalscore'), 10) + parseInt(points, 10);
        } else {
          var finalscore = window.totalscore;
        }
        Cookies.set('finalscore', finalscore, {
          expires: 7,
          path: '/',
        });
        Cookies.set($(this).parent('id'), 'QuestionDone', {
          expires: 7,
          path: '/',
        });
      }
    }
  }


  $('.MatchingQuestion').each(function (index) { // do this for each matching pair activity on the page
    // console.log( index + " matching question activity: " + $( this ).text() );
    const id = `#${$(this).attr('id')}`;
    // hide any individual feedback
    $('.matchingFeedbackDiv', id).hide();
    $('.Feedback', id).hide();
    $('.matchingresult-correct', id).removeClass('alert-success');
    $('.matchingresult-incorrect', id).removeClass('alert-error');
    // hide the reset button and show the 'submit' button
    $('.matchingFeedbackResetButton', id).hide();
    $('.scoreboard', id).hide();
    $('.matchingFeedbackButton', id).show();
    // shuffle the Info divs
    // $('.matchingInfo', id).shuffle();
    // make each info div dragable
    $('.matchingInfo', id).each(function (index, value) {
      debug('Init info', this);
      $(this).draggable({
        containment: id,
        // stack: '.matchingInfoDiv',
        cursor: 'move',
        revert: true,
      });
    });
    // make each target div droppable
    $('.matchingTarget', id).each(function (index, value) {
      debug('init target', this);
      $(this).droppable({
        accept: '.matchingInfo',
        hoverClass: 'hovered',
        tolerance: 'touch',
        drop: handleInfoDrop,
      });
    });

    // find the maximum score (if we're keeping score)
    let maxscore = 0;
    $('.matchingTarget', id).each(function (index, value) {
      maxscore += parseInt($(this).attr('data-score'));
    });
    $('.maxscore', id).text(maxscore);
    // set up the feedback button for this activity
    $('.matchingFeedbackButton', id).click(function (e) {
      // console.log('clicked for feedback');

      // When overall feedback is used it appears that the feedback button can be pressed before answering all the pairs
      if ($('.Feedback', id).hasClass('gh__matching-dnd__feedback--overall')) {
        const numToBeAnswered = $('.gh__matching-dnd__source', id).find('.gh__matching-dnd__source__option:not(".correct")').length; // Gets the number of options that haven't been marked with true
        if (numToBeAnswered > 0) return;
      }

      $('.Feedback', id).show();

      $('.matchingFeedbackDiv', id).show();
      $('.matchingresult-correct', id).addClass('alert-success');
      $('.matchingresult-incorrect', id).addClass('alert-error');
      $(this).hide();
      // $('.matchingFeedbackResetButton', id).show(); // sorry, resetting is not working at this time. you need to refresh the page for a reset
      if ($('.score', id).text() != '0') {
        $('.scoreboard', id).show();
      }
    });
    // set up the feedback reset button for this activity
    $('.matchingFeedbackResetButton', id).click(function (e) {
      // console.log('clicked for reset');
      $('.Feedback', id).hide();
      $('.matchingFeedbackDiv', id).hide();
      $('.Feedback', id).removeClass('alert-success');
      $('.Feedback', id).removeClass('alert-error');
      $('.matchingresult-correct', id).removeClass('alert-success');
      $('.matchingresult-incorrect', id).removeClass('alert-error');

      $('.matchingFeedback', id).removeClass('matchingresult-incorrect');
      $('.matchingFeedback', id).removeClass('matchingresult-correct');
      $('.matchingInfo', id).removeClass('matchingresult-correct');
      $('.matchingInfo', id).removeClass('matchingresult-incorrect');
      $('.matchingInfo', id).removeClass('correct');
      $(this).hide();
      $('.scoreboard', id).hide();
      $('.score', id).text('0');
      $('.matchingFeedbackButton', id).show();
      $('.matchingTarget', id).droppable('enable');
      $('.matchingInfo', id).draggable('enable');
      $('.matchingInfo', id).draggable('option', 'revert', true);
      $('.matchingInfo', id).each(function (index) {
        $(this).css('left', 'auto');
      });
    });
    $('.modal').on('hidden', () => {
      $('.Feedback').hide();
      $('.mcFeedback').hide();
      $('.matchingFeedbackDiv').hide();
      $('.Feedback').removeClass('alert-success');
      $('.Feedback').removeClass('alert-error');
      $('.matchingresult-correct').removeClass('alert-success');
      $('.matchingresult-incorrect').removeClass('alert-error');
      $('.matchingFeedback').removeClass('matchingresult-incorrect');
      $('.matchingFeedback').removeClass('matchingresult-correct');
      $('.matchingInfo').removeClass('matchingresult-correct');
      $('.matchingInfo').removeClass('matchingresult-incorrect');
      $('.matchingInfo').removeClass('correct');
      $('.scoreboard').hide();
      $('.matchingFeedbackResetButton').hide();
      // shuffle the Info divs
      $('.matchingInfo', id).shuffle();
      $('.score').text('0');
      $('.matchingFeedbackButton').show();
      $('.matchingTarget').droppable('enable');
      $('.matchingInfo').draggable('enable');
      $('.matchingInfo').draggable('option', 'revert', true);
      $('.matchingInfo').each(function (index) {
        $(this).css('left', 'auto');
      });
    });
  });
});



// WEBPACK FOOTER //
// Glasshouse/Core/js/matching.js